var panasonic_EUR7628010_VCR = {
    name: "EUR7628010_VCR",
    defaultCommandIndex: 1,
    commands: [
        {
            function: "KEY_POWER",
            name: "KEY_POWER",
            icon: "KEY_POWER",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,187,254,213,118,182,136],
        },
        {
            function: "KEY_REC",
            name: "KEY_REC",
            icon: "KEY_REC",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,187,255,223,235,162],
        },
        {
            function: "KEY_CHANNELDOWN",
            name: "KEY_CHANNELDOWN",
            icon: "KEY_CHANNELDOWN",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,187,254,218,237,218,32],
        },
        {
            function: "KEY_CHANNELUP",
            name: "KEY_CHANNELUP",
            icon: "KEY_CHANNELUP",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,187,255,181,247,104,128],
        },
        {
            function: "KEY_REWIND",
            name: "KEY_REWIND",
            icon: "KEY_REWIND",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,187,255,127,187,162],
        },
        {
            function: "KEY_FASTFORWARD",
            name: "KEY_FASTFORWARD",
            icon: "KEY_FASTFORWARD",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,187,254,191,174,232,128],
        },
        {
            function: "KEY_STOP",
            name: "KEY_STOP",
            icon: "KEY_STOP",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,187,255,255,238,136],
        },
        {
            function: "KEY_PAUSE",
            name: "KEY_PAUSE",
            icon: "KEY_PAUSE",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,187,255,95,214,232,128],
        },
        {
            function: "KEY_PLAY",
            name: "KEY_PLAY",
            icon: "KEY_PLAY",
            command: [100,0,4,219,1,138,1,219,1,245,4,245,13,146,6,213,1,218,34,55,255,191,187,255,111,218,232,128],
        },
    ]
}
export default panasonic_EUR7628010_VCR